<template>
  <div>
    <div class="withdraw_wrapper" v-show="!showResult">
      <div class="withdraw_all">
        <div class="title">
          现有余额：{{
            accountData.balance
              ? parseFloat(accountData.balance).toLocaleString()
              : 0
          }}
        </div>

        <div class="withdraw_form">
          <div class="form_item">
            <div class="label">到账账户</div>
            <div class="has_account">
              <div class="account">
                {{ user.mobile }}
              </div>
            </div>
          </div>
          <div class="form_title">
            充值金额
          </div>
          <div class="form_num">
            <div class="unit">￥</div>
            <van-field
              v-model.trim="amount"
              placeholder="请输入充值金额,最低1元"
              :border="false"
              type="number"
            >
              <template #button>
                <van-button
                  size="small"
                  color="linear-gradient(to right, #ff6034, #ee0a24)"
                  @click="getQrcode"
                >
                  立即充值
                </van-button>
              </template>
            </van-field>
          </div>
          <div class="qrcode_wrapper" v-show="showCode">
            <div class="text">打开支付宝扫一扫</div>
            <div id="QRCode">
              <canvas id="canvas"></canvas>
            </div>
            <div class="save">
              长按保存图片
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pay_result_container" v-show="showResult">
      <div v-show="pathResultType == 'success'">
        <van-icon name="checked" class="success_icon" />
        <div class="result_text">
          充值成功
        </div>
        <div class="pay_money">{{ payMsg }}</div>
      </div>

      <van-button
        round
        type="info"
        size="normal"
        color="#F93244"
        class="btn"
        @click="openPage('/')"
        >返回首页</van-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QRCode from "qrcode";

import { accountGet, rechargePay, rechargeList } from "@/api";
export default {
  data() {
    return {
      user: this.userInfo(),
      amount: "",
      showCode: false,
      accountData: {},
      showResult: false,
      pathResultType: "",
      payMsg: "",
      timeOutCount: 0, // 定时器执行次数
    };
  },
  mounted() {
    accountGet().then((res) => {
      this.accountData = res.data;
    });
  },
  methods: {
    ...mapGetters(["userInfo"]),
    openPage(path) {
      this.$router.push(path);
    },
    getQrcode() {
      if (parseFloat(this.amount) < 1) {
        return this.$toast.fail("充值金额最低为1元");
      }
      const params = {
        amount: this.amount,
        payway: "ALIPAY_QRCODE",
      };
      rechargePay(params).then((res) => {
        if (res.success) {
          //生成二维码
          this.useqrcode(res.data.qrCode);
          //展示二维码
          this.showCode = true;
          //检查支付状态
          this.checkPayStatus(res.data.no);
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    checkPayStatus(no) {
      this.timeOutCount++;
      if (this.timeOutCount > 60) {
        this.$toast.fail("3分钟未支付，取消支付状态检测");
      } else {
        rechargeList({ no }).then((res) => {
          let status = res.data.list[0].status;
          console.log(status);
          if (status == "SUCCESS") {
            //展示支付结果
            this.showResult = true;
            this.pathResultType = "success";
            this.payMsg = "充值金额：￥" + this.amount;
          } else {
            setTimeout(() => {
              this.checkPayStatus(no);
            }, 3000);
          }
        });
      }
    },
    useqrcode(url) {
      //url是生成二维码的内容
      let _this = this;

      //先清除fatherQrcode的img子节点：防止重复添加
      let fatherQrcode = document.getElementById("QRCode");
      let childs = fatherQrcode.children;
      for (var i = childs.length - 1; i >= 0; i--) {
        if (childs[i].className == "QRCode") {
          fatherQrcode.removeChild(childs[i]);
        }
      }

      //生成二维码
      var canvas = document.getElementById("canvas");
      QRCode.toCanvas(canvas, url, function(error) {
        if (error) console.error(error);
        //获取网页中的canvas对象转换为img
        var mycanvas1 = document.getElementsByTagName("canvas")[0];

        //隐藏生成的canvas
        mycanvas1.style.display = "none";
        //将转换后的img标签插入到html中
        var img = _this.convertCanvasToImage(mycanvas1);
        img.classList.add("QRCode"); //为img添加类名QRCode
        fatherQrcode.append(img); //imagQrDiv表示你要插入的容器id
      });
    },
    //转换为img
    convertCanvasToImage(canvas) {
      //新Image对象，可以理解为DOM
      var image = new Image();
      // canvas.toDataURL 返回的是一串Base64编码的URL， 指定格式 PNG
      image.src = canvas.toDataURL("image/png");
      return image;
    },
  },
};
</script>

<style lang="less" scoped>
.withdraw_wrapper {
  background-color: #f7f8fa;
  min-height: 100vh;
  .withdraw_all {
    height: 68.4vw;
    background: linear-gradient(138deg, #fd7343 0%, #f93244 100%);
    padding-top: 7.6vw;
    padding-left: 5.333vw;
    position: relative;

    .title {
      font-size: 4.533vw;
      color: #fff;
      margin-bottom: 3.2vw;
    }
  }
  .withdraw_form {
    height: 527.002px;
    border-radius: 2.133vw;
    background-color: #fff;
    position: absolute;
    left: 3.2vw;
    right: 3.2vw;
    top: 18.667vw;
    padding: 5.333vw 5.333vw 9.067vw;
    &::after {
      width: 93.6vw;
      content: "如有疑问请联系在线客服~";
      display: inline-block;
      overflow: hidden;
      position: absolute;
      bottom: -7.267vw;
      left: 0;
      text-align: center;
      font-size: 3.733vw;
      color: rgba(0, 0, 0, 0.45);
    }
    .form_item {
      .label {
        margin-bottom: 4.267vw;
        font-size: 3.733vw;
        color: rgba(0, 0, 0, 0.85);
      }
      .has_account {
        font-size: 3.733vw;
        .account {
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
    .form_title {
      margin-top: 8.533vw;
      font-size: 3.733vw;
      color: rgba(0, 0, 0, 0.85);
    }

    .form_num {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      margin-top: 7.467vw;
      padding-bottom: 3.2vw;
      .unit {
        font-size: 10.667vw;
        color: rgba(0, 0, 0, 0.85);
        margin-right: 2.133vw;
      }
    }
    .qrcode_wrapper {
      display: flex;
      align-items: center;
      flex-direction: column;
      .text {
        margin-top: 8.533vw;
        margin-bottom: 5.333vw;
        font-size: 3.733vw;
        color: rgba(0, 0, 0, 0.85);
      }
      #QRCode {
        margin-bottom: 3.2vw;
      }
      .save {
        font-size: 3.733vw;
        color: #f93244;
      }
    }
  }
}

.pay_result_container {
  padding: 17.067vw 4.267vw;
  text-align: center;
  .success_icon {
    font-size: 17.067vw;
    color: #f93244;
    margin-bottom: 8.533vw;
  }
  .fail_icon {
    font-size: 17.067vw;
    color: #bfbfbf;
    margin-bottom: 8.533vw;
  }
  .result_text {
    font-size: 5.333vw;

    color: #323233;
    margin-bottom: 4.267vw;
  }
  .pay_money {
    font-size: 3.733vw;
    color: rgba(0, 0, 0, 0.65);
    margin-bottom: 30vw;
  }
  .btn {
    width: 91.467vw;
    height: 11.733vw;
    margin-bottom: 5.333vw;
  }
}

/deep/ .van-cell {
  flex: 1;
  padding: 0;
}
</style>
